type BrandMarkProps = {
  variant?: "compact" | "full";
  className?: string;
  priority?: boolean;
};

export function BrandMark({ variant = "full", className = "", priority = false }: BrandMarkProps) {
  const compact = variant === "compact";
  return (
    <div className={`flex min-w-0 items-center gap-3 ${className}`}>
      <span className="relative block size-10 shrink-0 overflow-hidden rounded-[10px] border border-[var(--hc-border-strong)] bg-white">
        <img
          src={compact ? "/brand/horosho-favicon-mark.png" : "/brand/horosho-brand-mark.png"}
          alt="Horosho Capital"
          width={40}
          height={40}
          loading={priority ? "eager" : "lazy"}
          fetchPriority={priority ? "high" : "auto"}
          className="size-full object-cover"
        />
      </span>
      {compact ? null : (
        <span className="min-w-0 leading-tight">
          <span className="block truncate text-sm font-semibold tracking-[-0.01em] text-[var(--hc-text)]">Horosho Capital</span>
          <span className="mt-0.5 block text-[11px] font-medium uppercase tracking-[0.14em] text-[var(--hc-muted)]">
            Macro Intelligence
          </span>
        </span>
      )}
    </div>
  );
}
